import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from 'config/api';

const usersApi = createApi({
  reducerPath: 'usersApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
  }),
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: () => 'site_user',
    }),
  }),
});

export const { useGetUsersQuery } = usersApi;
export default usersApi;
